/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFaqCategoryDto } from '../../models/lexplus-faq-category-dto';

export interface FaqControllerFindAllByCategoryV1$Params {
}

export function faqControllerFindAllByCategoryV1(http: HttpClient, rootUrl: string, params?: FaqControllerFindAllByCategoryV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusFaqCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, faqControllerFindAllByCategoryV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusFaqCategoryDto>>;
    })
  );
}

faqControllerFindAllByCategoryV1.PATH = '/v1/faq/by-category';
